// src/components/MenuHeader.jsx - New standalone component
import React from 'react';
import { styled } from '@mui/material/styles';
import {
  Box,
  Typography,
  IconButton,
  Tooltip
} from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

const HeaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1),
  backgroundColor: theme.palette.mode === 'dark' 
    ? theme.palette.grey[900]
    : theme.palette.grey[800],
  color: theme.palette.common.white,
  height: 48,
  width: '100%',
}));

// Left section containing settings button
const LeftSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  flex: '1 0 0',
});

// Center section containing title
const CenterSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '1 0 0',
});

// Right section containing close button
const RightSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  flex: '1 0 0',
});

const HeaderTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: '1rem',
  color: theme.palette.common.white,
}));

const HeaderButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.common.white,
  padding: 8,
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
  },
}));

const MenuHeader = ({ onSettingsClick, onClose }) => {
  const { t } = useTranslation();

  return (
    <HeaderContainer>
      {/* Left-aligned section with settings button */}
      <LeftSection>
        <Tooltip title={t('settings.title')}>
          <HeaderButton onClick={onSettingsClick} size="small">
            <SettingsIcon fontSize="small" />
          </HeaderButton>
        </Tooltip>
      </LeftSection>
      
      {/* Center-aligned section with menu title */}
      <CenterSection>
        <HeaderTitle>{t('menu.title')}</HeaderTitle>
      </CenterSection>
      
      {/* Right-aligned section with close button */}
      <RightSection>
        <Tooltip title={t('menu.close')}>
          <HeaderButton onClick={onClose} size="small">
            <CloseIcon fontSize="small" />
          </HeaderButton>
        </Tooltip>
      </RightSection>
    </HeaderContainer>
  );
};

export default MenuHeader;